import { Component, ElementRef, HostListener, input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-popup',
  imports: [],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.css',
})
export class PopupComponent {
  public wide = input<boolean>(false);
  protected isVisible = false;
  protected positionClass = 'right bottom';
  private width = 300;
  private height = 300;
  @ViewChild('trigger', { static: true }) triggerRef!: ElementRef;

  @HostListener('mouseover', ['$event'])
  onMouseOver(_: MouseEvent): void {
    this.isVisible = true;
    this.adjustPosition();
  }

  @HostListener('mouseout')
  onMouseOut(): void {
    this.isVisible = false;
  }

  private adjustPosition() {
    const element = this.triggerRef.nativeElement;
    const rect = element.getBoundingClientRect();

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    this.positionClass = rect.right + this.width > viewportWidth ? 'left' : 'right';
    this.positionClass += rect.bottom + this.height > viewportHeight ? ' top' : ' bottom';
  }
}
